module.exports = __webpack_public_path__ + "static/media/icon-client-plus.237dcc60.svg";